// extracted by mini-css-extract-plugin
module.exports = {"also-read":"alsoRead-m__also-read__2AXuw","wrapper":"alsoRead-m__wrapper__2VTfW","no-image":"alsoRead-m__no-image__1FkxC","more":"alsoRead-m__more__1cg90"};